const Condo: any = (
  style = {},
  fill = '#000',
  width = '100%',
  height = '100%',
  viewBox = '0 0 64 65',
) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M5.03039 55.0498C4.47739 55.0498 4.02539 54.6028 4.02539 54.0498C4.02539 53.4968 4.46739 53.0498 5.01939 53.0498H5.03039C5.58239 53.0498 6.03039 53.4968 6.03039 54.0498C6.03039 54.6028 5.58239 55.0498 5.03039 55.0498Z"
      fill={fill}
    />
    <path
      d="M1.00078 15.0498C0.681778 15.0498 0.367778 14.8978 0.174778 14.6138C-0.137222 14.1578 -0.0202222 13.5358 0.435778 13.2238L19.4358 0.223827C19.8928 -0.0881729 20.5148 0.0298271 20.8258 0.484827C21.1378 0.940827 21.0208 1.56283 20.5648 1.87483L1.56478 14.8748C1.39178 14.9928 1.19478 15.0498 1.00078 15.0498Z"
      fill={fill}
    />
    <path
      d="M38.9993 15.0498C38.8053 15.0498 38.6083 14.9928 38.4363 14.8748L19.4363 1.87483C18.9803 1.56283 18.8643 0.940827 19.1753 0.484827C19.4863 0.0298271 20.1083 -0.0881729 20.5653 0.223827L39.5653 13.2238C40.0213 13.5358 40.1373 14.1578 39.8263 14.6138C39.6323 14.8978 39.3183 15.0498 38.9993 15.0498Z"
      fill={fill}
    />
    <path
      d="M1.00078 19.0498C0.681778 19.0498 0.367778 18.8978 0.174778 18.6138C-0.137222 18.1578 -0.0202222 17.5358 0.435778 17.2238L19.4358 4.22378C19.8928 3.91078 20.5148 4.02978 20.8258 4.48478C21.1378 4.94078 21.0208 5.56278 20.5648 5.87478L1.56478 18.8748C1.39178 18.9928 1.19478 19.0498 1.00078 19.0498Z"
      fill={fill}
    />
    <path
      d="M38.9993 19.0498C38.8053 19.0498 38.6083 18.9928 38.4363 18.8748L19.4363 5.87483C18.9803 5.56283 18.8643 4.94083 19.1753 4.48483C19.4863 4.02983 20.1083 3.91183 20.5653 4.22383L39.5653 17.2238C40.0213 17.5358 40.1373 18.1578 39.8263 18.6138C39.6323 18.8978 39.3183 19.0498 38.9993 19.0498Z"
      fill={fill}
    />
    <path
      d="M1 19.0498C0.447 19.0498 0 18.6028 0 18.0498V14.0498C0 13.4968 0.447 13.0498 1 13.0498C1.553 13.0498 2 13.4968 2 14.0498V18.0498C2 18.6028 1.553 19.0498 1 19.0498Z"
      fill={fill}
    />
    <path
      d="M39 19.0498C38.447 19.0498 38 18.6028 38 18.0498V14.0498C38 13.4968 38.447 13.0498 39 13.0498C39.553 13.0498 40 13.4968 40 14.0498V18.0498C40 18.6028 39.553 19.0498 39 19.0498Z"
      fill={fill}
    />
    <path
      d="M26 21.0498C25.447 21.0498 25 20.6028 25 20.0498C25 17.2928 22.757 15.0498 20 15.0498C17.243 15.0498 15 17.2928 15 20.0498C15 20.6028 14.553 21.0498 14 21.0498C13.447 21.0498 13 20.6028 13 20.0498C13 16.1908 16.141 13.0498 20 13.0498C23.859 13.0498 27 16.1908 27 20.0498C27 20.6028 26.553 21.0498 26 21.0498Z"
      fill={fill}
    />
    <path
      d="M14 29.0498C13.447 29.0498 13 28.6028 13 28.0498V20.0498C13 19.4968 13.447 19.0498 14 19.0498C14.553 19.0498 15 19.4968 15 20.0498V28.0498C15 28.6028 14.553 29.0498 14 29.0498Z"
      fill={fill}
    />
    <path
      d="M28 36.0498H12C11.447 36.0498 11 35.6028 11 35.0498C11 34.4968 11.447 34.0498 12 34.0498H28C28.553 34.0498 29 34.4968 29 35.0498C29 35.6028 28.553 36.0498 28 36.0498Z"
      fill={fill}
    />
    <path
      d="M28 29.0498H12C11.447 29.0498 11 28.6028 11 28.0498C11 27.4968 11.447 27.0498 12 27.0498H28C28.553 27.0498 29 27.4968 29 28.0498C29 28.6028 28.553 29.0498 28 29.0498Z"
      fill={fill}
    />
    <path
      d="M26 29.0498C25.447 29.0498 25 28.6028 25 28.0498V20.0498C25 19.4968 25.447 19.0498 26 19.0498C26.553 19.0498 27 19.4968 27 20.0498V28.0498C27 28.6028 26.553 29.0498 26 29.0498Z"
      fill={fill}
    />
    <path
      d="M12 36.0498C11.447 36.0498 11 35.6028 11 35.0498V28.0498C11 27.4968 11.447 27.0498 12 27.0498C12.553 27.0498 13 27.4968 13 28.0498V35.0498C13 35.6028 12.553 36.0498 12 36.0498Z"
      fill={fill}
    />
    <path
      d="M28 36.0498C27.447 36.0498 27 35.6028 27 35.0498V28.0498C27 27.4968 27.447 27.0498 28 27.0498C28.553 27.0498 29 27.4968 29 28.0498V35.0498C29 35.6028 28.553 36.0498 28 36.0498Z"
      fill={fill}
    />
    <path
      d="M16 36.0498C15.447 36.0498 15 35.6028 15 35.0498V28.0498C15 27.4968 15.447 27.0498 16 27.0498C16.553 27.0498 17 27.4968 17 28.0498V35.0498C17 35.6028 16.553 36.0498 16 36.0498Z"
      fill={fill}
    />
    <path
      d="M20 36.0498C19.447 36.0498 19 35.6028 19 35.0498V28.0498C19 27.4968 19.447 27.0498 20 27.0498C20.553 27.0498 21 27.4968 21 28.0498V35.0498C21 35.6028 20.553 36.0498 20 36.0498Z"
      fill={fill}
    />
    <path
      d="M24 36.0498C23.447 36.0498 23 35.6028 23 35.0498V28.0498C23 27.4968 23.447 27.0498 24 27.0498C24.553 27.0498 25 27.4968 25 28.0498V35.0498C25 35.6028 24.553 36.0498 24 36.0498Z"
      fill={fill}
    />
    <path
      d="M3 64.0496C2.447 64.0496 2 63.6026 2 63.0496V16.6816C2 16.1286 2.447 15.6816 3 15.6816C3.553 15.6816 4 16.1286 4 16.6816V63.0496C4 63.6026 3.553 64.0496 3 64.0496Z"
      fill={fill}
    />
    <path
      d="M37 64.0496C36.447 64.0496 36 63.6026 36 63.0496V16.6816C36 16.1286 36.447 15.6816 37 15.6816C37.553 15.6816 38 16.1286 38 16.6816V63.0496C38 63.6026 37.553 64.0496 37 64.0496Z"
      fill={fill}
    />
    <path
      d="M63 64.0498H3C2.447 64.0498 2 63.6028 2 63.0498C2 62.4968 2.447 62.0498 3 62.0498H63C63.553 62.0498 64 62.4968 64 63.0498C64 63.6028 63.553 64.0498 63 64.0498Z"
      fill={fill}
    />
    <path
      d="M63 41.0498H3C2.447 41.0498 2 40.6028 2 40.0498C2 39.4968 2.447 39.0498 3 39.0498H63C63.553 39.0498 64 39.4968 64 40.0498C64 40.6028 63.553 41.0498 63 41.0498Z"
      fill={fill}
    />
    <path
      d="M12 46.0498H3C2.447 46.0498 2 45.6028 2 45.0498C2 44.4968 2.447 44.0498 3 44.0498H12C12.553 44.0498 13 44.4968 13 45.0498C13 45.6028 12.553 46.0498 12 46.0498Z"
      fill={fill}
    />
    <path
      d="M12 64.0498C11.447 64.0498 11 63.6028 11 63.0498V45.0498C11 44.4968 11.447 44.0498 12 44.0498C12.553 44.0498 13 44.4968 13 45.0498V63.0498C13 63.6028 12.553 64.0498 12 64.0498Z"
      fill={fill}
    />
    <path
      d="M32 57.0498H17C16.447 57.0498 16 56.6028 16 56.0498V45.0498C16 44.4968 16.447 44.0498 17 44.0498H32C32.553 44.0498 33 44.4968 33 45.0498V56.0498C33 56.6028 32.553 57.0498 32 57.0498ZM18 55.0498H31V46.0498H18V55.0498Z"
      fill={fill}
    />
    <path
      d="M63 64.0498C62.447 64.0498 62 63.6028 62 63.0498V40.0498C62 39.4968 62.447 39.0498 63 39.0498C63.553 39.0498 64 39.4968 64 40.0498V63.0498C64 63.6028 63.553 64.0498 63 64.0498Z"
      fill={fill}
    />
    <path
      d="M63 41.0498H37C36.447 41.0498 36 40.6028 36 40.0498V37.0498C36 36.4968 36.447 36.0498 37 36.0498H63C63.553 36.0498 64 36.4968 64 37.0498V40.0498C64 40.6028 63.553 41.0498 63 41.0498ZM38 39.0498H62V38.0498H38V39.0498Z"
      fill={fill}
    />
    <path
      d="M41 64.0498C40.447 64.0498 40 63.6028 40 63.0498V47.0498C40 46.4968 40.447 46.0498 41 46.0498C41.553 46.0498 42 46.4968 42 47.0498V63.0498C42 63.6028 41.553 64.0498 41 64.0498Z"
      fill={fill}
    />
    <path
      d="M59 48.0498H41C40.447 48.0498 40 47.6028 40 47.0498C40 46.4968 40.447 46.0498 41 46.0498H59C59.553 46.0498 60 46.4968 60 47.0498C60 47.6028 59.553 48.0498 59 48.0498Z"
      fill={fill}
    />
    <path
      d="M59 64.0498C58.447 64.0498 58 63.6028 58 63.0498V47.0498C58 46.4968 58.447 46.0498 59 46.0498C59.553 46.0498 60 46.4968 60 47.0498V63.0498C60 63.6028 59.553 64.0498 59 64.0498Z"
      fill={fill}
    />
    <path
      d="M59 52.0498H41C40.447 52.0498 40 51.6028 40 51.0498C40 50.4968 40.447 50.0498 41 50.0498H59C59.553 50.0498 60 50.4968 60 51.0498C60 51.6028 59.553 52.0498 59 52.0498Z"
      fill={fill}
    />
    <path
      d="M59 56.0498H41C40.447 56.0498 40 55.6028 40 55.0498C40 54.4968 40.447 54.0498 41 54.0498H59C59.553 54.0498 60 54.4968 60 55.0498C60 55.6028 59.553 56.0498 59 56.0498Z"
      fill={fill}
    />
    <path
      d="M59 60.0498H41C40.447 60.0498 40 59.6028 40 59.0498C40 58.4968 40.447 58.0498 41 58.0498H59C59.553 58.0498 60 58.4968 60 59.0498C60 59.6028 59.553 60.0498 59 60.0498Z"
      fill={fill}
    />
  </svg>
)

export default Condo
